import React, { useEffect } from "react";
import StripeCheckout from "./stripePayment";
import RazorpayCheckout from "./razorpayCheckout";
import api from '../../api/api';
import { useDispatch, useSelector } from "react-redux";
import { proceedToPayData } from "../../state/actions/coursePaymentAction";
import { useAuth } from "../../features/auth/AuthContext";
import { useLocation } from "react-router";
import PracticeAssignmentStripePayment from "./PracticeAssignmentStripePayment";

const Checkout = () => {
  const { token } = useAuth();
  const dispatch= useDispatch();
  const location = useLocation(); //on the basis of location state we will decide which payment component to render
  const {isAssignment} = location.state || {};
  
  

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            {
              isAssignment ? <PracticeAssignmentStripePayment/> : <StripeCheckout/>
            }
          </div>
        </div>
      </div>  
    </>
  );
};

export default Checkout;